import $ from 'jquery';
import Swiper , { Autoplay } from 'swiper';

function initLogosSlider() {
    $(function () {
        if ($('.logos-slider').length <= 0) {
            return;
        }

        //customizeSliderStyles();
        initSwiperLogosJS();
    });
}

function initSwiperLogosJS(elements) {
    Swiper.use([Autoplay]);
    $('.logos-slider').each(function(){
        let slider1 = $(this).find('.slider-1');
        let slider2 = $(this).find('.slider-2');

        //duplicate slides
        function duplicateSlides(slider) {
            const screenWidth = $(window).width();
            let totalSlidesWidth = 0;
        
            // Calculate the total width of all original slides
            slider.find('.swiper-slide').each(function() {
                if($(this).outerWidth(true) != 0){
                    totalSlidesWidth += $(this).outerWidth(true)>150?$(this).outerWidth(true):150;
                    //console.log($(this).outerWidth(true));
                } else{
                    totalSlidesWidth += 150;
                }
            });
        
            // Safeguard to prevent infinite duplication if totalSlidesWidth is somehow 0
            if (totalSlidesWidth === 0) {
                console.error('Error: Total slides width is 0. Duplication skipped.');
                return;
            }
        
            // Calculate how many times to duplicate based on needing at least twice the screen width
            const duplicationFactor = Math.ceil((screenWidth * 2) / totalSlidesWidth) - 1; // Subtract 1 because we already have the original set of slides
            console.log(duplicationFactor);
            let sliderWrapper = slider.find('.swiper-wrapper');
            // Duplicate the slides the calculated number of times
            for (let i = 0; i < duplicationFactor; i++) {
                slider.find('.swiper-slide').clone().appendTo(sliderWrapper);
            }
        }
        duplicateSlides(slider1);
        duplicateSlides(slider2);
        

        // Initialize the first slider
        if(slider1.length){
           
            new Swiper(slider1.get(0), {
                spaceBetween: 0,
                centeredSlides: false,
                autoplay: {
                    delay: 1,
                },
                speed: 8000,
                loop: true,
                slidesPerView:'auto',
                allowTouchMove: false,
                disableOnInteraction: true
            });
        }

        // Initialize the second slider with reversed direction
        if(slider2.length){
            
            new Swiper(slider2.get(0), {
                spaceBetween: 0,
                centeredSlides: false,
                autoplay: {
                    delay: 1,
                    reverseDirection: true
                },
                speed: 8000,
                loop: true,
                slidesPerView:'auto',
                allowTouchMove: false,
                disableOnInteraction: true
            });
        }
    });
    
}

export { initLogosSlider };